import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { IonCol, IonGrid, IonRow } from "@ionic/vue";

import OrderItem from "@/components/various/OrderItem.vue";

import { CartData } from "@/types/supplier";
import { onActivated } from "vue";
import { useSupplierStore } from "@/stores/suppliers";
import { useI18n } from "vue-i18n";
import { replaceToast } from "@/functions/baseToast";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDelivery',
  props: {
    cartData: {}
  },
  emits: ['back'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const { t } = useI18n()

onActivated(() => {
    if (!useSupplierStore().deliveryDays[props.cartData.supplier?.id]) {
        replaceToast({
            message: t('messages.cartDataMissing'),
            id: 'cart-data-missing'
        })
        emit('back')
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), { class: "p-0 max-height purple-purple-color" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), { class: "grey4-grey4-background mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('messages.order.overview')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cartData.summary, (item) => {
        return (_openBlock(), _createBlock(_unref(IonRow), {
          key: item.id
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "px-3" }, {
              default: _withCtx(() => [
                _createVNode(OrderItem, { entry: item }, null, 8, ["entry"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})